/*
 * @Description: 
 * @Author: Guojun
 * @Date: 2020-5-19 15:03:51
 * @LastEditTime: 2020-5-20 09:03:51
 * @LastEditors: Guojun
 */
import Vue from 'vue'
import store from '@/stores/index';
import router from '@/routers/router'
import modelLogin  from '../components/modelLogin';
//使用vue的extend，以vue文件为基础组件，返回一个可以创建vue组件的特殊构造函数
const ToastConstructor  =  Vue.extend({...modelLogin, store,router})
 
function showToast(show){
    const toastDom = new ToastConstructor({
        el : document.createElement('div'),
        data(){
            return {
                show:show
            }
        }
    })　　//在body中动态创建一个div元素，后面自动会把它替换成整个vue文件内的内容
    let oldDom = document.querySelector(".model_bg");
    oldDom ?  document.body.appendChild(oldDom) : document.body.appendChild(toastDom.$el)
}
function registryToast (){
    //把showToast这个方法添加到vue的原型中，可以直接调用，当调用的时候就是执行函数内的内容
    Vue.prototype.$toast = showToast
}
export default registryToast